import { Directive, ElementRef, AfterViewInit, Input, inject } from '@angular/core';

import { MatInput } from '@angular/material/input';

@Directive({
    selector: '[autoFocus1]',
    standalone: true,
})
export class AutofocusDirective implements AfterViewInit {
  private _matInput = inject(MatInput, { host: true });
  private _el = inject(ElementRef);


  @Input() public autoFocus = true;

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this._matInput.focus();
    }, 100);
  }

}
